export default process.env.NEXT_PUBLIC_APP_URL || 'beatgig.com'
